import { forwardRef } from 'react';
import { Stack, Tooltip } from '@mui/material';
import { Button, colors, IconButton } from '@sweep-io/sweep-design';
import { Plus } from '@sweep-io/sweep-design/dist/icons';

interface AddMetadataButtonProps {
  compact?: boolean;
  disabled?: boolean;
  isPopoverOpen: boolean;
  onClick: (event?: React.MouseEvent) => void;
}

const MAX_TABS_TOOLTIP = 'Maximum tabs reached. Close a tab to open another.';

export const AddMetadataButton = forwardRef<HTMLDivElement, AddMetadataButtonProps>(
  ({ compact = false, disabled = false, isPopoverOpen, onClick }, ref) => {
    return (
      <Stack
        data-testid="add-metadata-button"
        ref={ref}
        sx={{
          ml: 0,
          flexShrink: 0,
          mr: 1,
          pl: 1,
          alignItems: 'center',
          height: '100%',
          justifyContent: 'center',
          '& button': {
            minWidth: '0',
          },
        }}
      >
        <Tooltip
          title={disabled ? MAX_TABS_TOOLTIP : compact ? 'Add Metadata Type' : ''}
          placement="top"
          disableHoverListener={disabled ? false : !compact}
        >
          <span>
            {compact ? (
              <Stack
                sx={{
                  '& button': {
                    '& svg path': {
                      stroke: disabled ? undefined : colors.blue[500],
                    },
                  },
                }}
              >
                <IconButton
                  pressed={isPopoverOpen}
                  variant="flat"
                  disabled={disabled}
                  onClick={onClick}
                  size="tiny"
                >
                  <Plus size="medium" />
                </IconButton>
              </Stack>
            ) : (
              <Button
                pressed={isPopoverOpen}
                variant="flat-blue"
                disabled={disabled}
                onClick={onClick}
                size="tiny"
              >
                + Add Metadata Type
              </Button>
            )}
          </span>
        </Tooltip>
      </Stack>
    );
  },
);
